module.exports = __webpack_public_path__ + "static/media/reward-points-growth-icon.36de2397.svg";